import { Flex, Progress } from 'antd';
import { useTranslation } from 'react-i18next';
import { spacing, textColor } from '../../theming';
import { mutedSmallStyle, thresholdMarkerStyle } from './vinExtractionStyles';

const percentOf = value => Math.min(100, Math.max(0, value * 100));

/** The confidence bar with a marker at the threshold; no marker when no threshold is known. */
const AttemptConfidenceBar = ({ attempt, threshold, thresholdIsCurrent }) => {
    const { t } = useTranslation('vinExtraction');
    const value = attempt.confidence.toFixed(2);
    const thresholdText = threshold === null ? null : threshold.toFixed(2);
    const color = attempt.lowConfidence ? textColor.warning : textColor.success;

    return (
        <Flex vertical gap={spacing[0.5]}>
            <div
                role="img"
                aria-label={
                    thresholdText
                        ? t('drawer.attempt.barAria', { value, threshold: thresholdText })
                        : t('drawer.attempt.barAriaNoThreshold', { value })
                }
                style={{ position: 'relative' }}
            >
                <Progress percent={percentOf(attempt.confidence)} showInfo={false} strokeColor={color} size="small" />
                {thresholdText && <span style={thresholdMarkerStyle(percentOf(threshold))} aria-hidden="true" />}
            </div>
            {thresholdText && (
                <span style={mutedSmallStyle}>
                    {t(thresholdIsCurrent ? 'drawer.attempt.thresholdCurrent' : 'drawer.attempt.threshold', {
                        value: thresholdText,
                    })}
                </span>
            )}
        </Flex>
    );
};

export default AttemptConfidenceBar;
